import React from "react"
export function Location(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10.002 2.001c3.59 0 6.5 2.78 6.5 6.209 0 2.098-1.825 5.21-5.474 9.336a1.391 1.391 0 01-1.936.117l-.116-.117-.359-.41c-3.41-3.923-5.115-6.898-5.115-8.926 0-3.43 2.91-6.209 6.5-6.209zm-.006 2.927c-1.463 0-2.65 1.162-2.65 2.595 0 1.434 1.187 2.596 2.65 2.596 1.464 0 2.65-1.162 2.65-2.596 0-1.433-1.186-2.595-2.65-2.595z"
        fill="currentColor"
        id="prefix__location"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
